import { DocumentNode } from 'graphql';
import { GraphQLClient } from 'graphql-request';

import { convertGraphQLClientErrorToGraphQLError } from '~/repository/graphql/cocolocala-bff/errorConverter';
import { GetConfigUtil } from '~/shared/utils/envUtil';

const getGqlString = (doc: DocumentNode) => {
  return doc.loc && doc.loc.source.body;
};

type Variables = {
  [key: string]: any;
};

const createClient = () => {
  const endpoint =
    GetConfigUtil.getPublicStaticConfig().COCOLOCALA_BFF_SERVER_URL +
    '/graphql';

  return new GraphQLClient(endpoint);
};

export function fetchGraphQL<T>(
  document: DocumentNode,
  variables?: Variables,
  options?: {
    userAgent?: string;
    authorization?: string;
  }
): Promise<T> {
  const client = createClient();
  if (options) {
    if (options.userAgent) {
      client.setHeader('User-Agent', options.userAgent);
    }
    if (options.authorization) {
      client.setHeader('Authorization', options.authorization);
    }
  }

  return client
    .request(getGqlString(document)!, variables)
    .then(result => {
      return result as T;
    })
    .catch(error => {
      throw convertGraphQLClientErrorToGraphQLError(document, variables, error);
    });
}
